'use client'

import { XCircle } from 'lucide-react'

type Props = {
  onSkip: () => void
  label?: string
  disabled: boolean
}

const SkipRepoSelection = ({
  onSkip,
  label = 'Continue without selecting',
  disabled
}: Props) => {
  return (
    <div
      role='button'
      aria-disabled={disabled}
      onClick={!disabled ? onSkip : () => {}}
      className={`flex-1 transform cursor-pointer transition-all duration-300 hover:scale-105 ${disabled ? 'pointer-events-none opacity-50' : ''} `}
      tabIndex={disabled ? -1 : 0}
    >
      <div className='relative flex h-28 w-full max-w-sm flex-col overflow-hidden rounded-lg border border-dashed border-gray-300 hover:border-gray-400'>
        <div className='flex h-full flex-col items-center justify-center bg-gray-50 p-4'>
          <XCircle className='mb-2 h-6 w-6 text-gray-400' />
          <p className='text-center text-xs text-gray-600'>{label}</p>
        </div>
      </div>
    </div>
  )
}

export default SkipRepoSelection
